import { AnyAction } from 'redux';

export default function setLocale(locale: $TSFixMe): AnyAction {
  return {
    type: 'SET_LOCALE',
    locale,
  };
}
